import Primary from './primary';
import PrimaryButton from './primaryButton';
import SecondaryButton from './secondaryButton';
import TertiaryButton from './tertiaryButton';
import { Size } from '../Button/button';
var StyledLink = {
    Size: Size,
    Primary: Primary,
    PrimaryButton: PrimaryButton,
    SecondaryButton: SecondaryButton,
    TertiaryButton: TertiaryButton,
};
export default StyledLink;
//# sourceMappingURL=index.js.map